// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo img {
    width: 98px;
    height: 40px;
}

.headingContainer {
    flex-grow: 1;
    display: flex;
    justify-content: center;
    text-align: center;
}

.head {
    transition: background 0.3s ease;
    background: #1e1e1e;
    color: white;
}

.head .heading {
    color: #f0f0f0;
    font-weight: 700;
    font-size: 1.4rem; /* Increased from previous size */
    margin: 0;
    padding: 0.5rem 0;
}

.profile {
    transition: all 0.2s ease;
}

.head .profile:hover {
    opacity: 0.9;
}

.head .iconHead {
    color: #f0f0f0;
}

.btn-shinenav {
  cursor: pointer;
  padding: 11px 0px;
  color: #fff;
  background: linear-gradient(to right, #4ab44c 0, #0055a5 10%, #00b5ec 20%);
  background-size: 700px auto; /* key change: much wider */
  background-position: 0 50%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: shine 10s infinite linear;
  animation-fill-mode: forwards;
  font-weight: 600;
  font-size: 35px;
  text-decoration: none;
  white-space: nowrap;
  font-family: "Poppins", sans-serif;
}


@keyframes shine {
  0% {
    background-position: 0 50%;
  }
  100% {
    background-position: 700px 50%;
  }
}



@media (max-width: 1024px) {
    .heading {
        font-size: 1.5rem; /* Adjusted for tablet size */
    }
}

@media (max-width: 768px) {
    .container.flexSB {
        flex-direction: column;
        padding: 10px 0;
    }
    
    .heading {
        font-size: 1.3rem; /* Adjusted for mobile */
        margin: 10px 0;
    }
    
    .right.flexCenter {
        margin-top: 10px;
    }
}

@media (max-width: 480px) {
    .logo img {
        width: 80px;
        height: 32px;
    }
    
    .heading {
        font-size: 1.1rem; /* Adjusted for small mobile */
    }
    
    .profile span {
        font-size: 0.9rem;
    }
    
    .iconHead {
        font-size: 1.2rem !important;
    }
}

@media (max-width: 360px) {
    .heading {
        font-size: 1rem; /* Minimum size for very small screens */
    }
    
    .profile span {
        font-size: 0.8rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/head/head.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB,EAAE,iCAAiC;IACpD,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,0EAA0E;EAC1E,2BAA2B,EAAE,2BAA2B;EACxD,0BAA0B;EAC1B,6BAA6B;EAC7B,oCAAoC;EACpC,oCAAoC;EACpC,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,kCAAkC;AACpC;;;AAGA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,8BAA8B;EAChC;AACF;;;;AAIA;IACI;QACI,iBAAiB,EAAE,6BAA6B;IACpD;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,eAAe;IACnB;;IAEA;QACI,iBAAiB,EAAE,wBAAwB;QAC3C,cAAc;IAClB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,iBAAiB,EAAE,8BAA8B;IACrD;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI,eAAe,EAAE,wCAAwC;IAC7D;;IAEA;QACI,iBAAiB;IACrB;AACJ","sourcesContent":[".logo img {\n    width: 98px;\n    height: 40px;\n}\n\n.headingContainer {\n    flex-grow: 1;\n    display: flex;\n    justify-content: center;\n    text-align: center;\n}\n\n.head {\n    transition: background 0.3s ease;\n    background: #1e1e1e;\n    color: white;\n}\n\n.head .heading {\n    color: #f0f0f0;\n    font-weight: 700;\n    font-size: 1.4rem; /* Increased from previous size */\n    margin: 0;\n    padding: 0.5rem 0;\n}\n\n.profile {\n    transition: all 0.2s ease;\n}\n\n.head .profile:hover {\n    opacity: 0.9;\n}\n\n.head .iconHead {\n    color: #f0f0f0;\n}\n\n.btn-shinenav {\n  cursor: pointer;\n  padding: 11px 0px;\n  color: #fff;\n  background: linear-gradient(to right, #4ab44c 0, #0055a5 10%, #00b5ec 20%);\n  background-size: 700px auto; /* key change: much wider */\n  background-position: 0 50%;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  animation: shine 10s infinite linear;\n  animation-fill-mode: forwards;\n  font-weight: 600;\n  font-size: 35px;\n  text-decoration: none;\n  white-space: nowrap;\n  font-family: \"Poppins\", sans-serif;\n}\n\n\n@keyframes shine {\n  0% {\n    background-position: 0 50%;\n  }\n  100% {\n    background-position: 700px 50%;\n  }\n}\n\n\n\n@media (max-width: 1024px) {\n    .heading {\n        font-size: 1.5rem; /* Adjusted for tablet size */\n    }\n}\n\n@media (max-width: 768px) {\n    .container.flexSB {\n        flex-direction: column;\n        padding: 10px 0;\n    }\n    \n    .heading {\n        font-size: 1.3rem; /* Adjusted for mobile */\n        margin: 10px 0;\n    }\n    \n    .right.flexCenter {\n        margin-top: 10px;\n    }\n}\n\n@media (max-width: 480px) {\n    .logo img {\n        width: 80px;\n        height: 32px;\n    }\n    \n    .heading {\n        font-size: 1.1rem; /* Adjusted for small mobile */\n    }\n    \n    .profile span {\n        font-size: 0.9rem;\n    }\n    \n    .iconHead {\n        font-size: 1.2rem !important;\n    }\n}\n\n@media (max-width: 360px) {\n    .heading {\n        font-size: 1rem; /* Minimum size for very small screens */\n    }\n    \n    .profile span {\n        font-size: 0.8rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
